<template>
    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 29.9 29.9" style="enable-background:new 0 0 29.9 29.9;" xml:space="preserve">
        <g>
            <path class="facebook" d="M27.6,0.7H2.4C1.1,0.7,0,1.7,0,3.1v23.8c0,1.3,1.1,2.4,2.4,2.4h25.2c1.3,0,2.4-1.1,2.4-2.4V3.1
        C29.9,1.7,28.9,0.7,27.6,0.7z M20.1,9.2c-0.6-0.4-1.1-0.6-1.7-0.6c-0.6,0-1.1,0.2-1.4,0.4c-0.3,0.3-0.4,0.7-0.4,1.5v1.1h3.2l-0.7,3
        h-2.5v9.9h-4.1v-9.9h-1.9v-3h1.9v-1.1c0-1.2,0.1-1.9,0.4-2.5c0.3-0.6,0.8-1.2,1.6-1.6c0.8-0.4,1.9-0.6,3-0.6c1.2,0,2.1,0.4,3.3,0.7
        L20.1,9.2z" />
        </g>
    </svg>
</template>
<style type="text/css">
.dark .facebook {
    fill: #FCEA0D;
}
.facebook {
    fill: #1977f3;
}

</style>
